import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "site-header-ribbon__content" }
const _hoisted_2 = { class: "site-header-ribbon__left site-header-ribbon__hide-on-phone" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "site-header-ribbon__middle text-editor-content site-header-ribbon__shopping-as"
}
const _hoisted_5 = { class: "site-header-ribbon__right site-header-ribbon__hide-on-phone" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_channel_switcher = _resolveComponent("channel-switcher")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'site-header-ribbon',
      {
        'site-header-ribbon__hide-on-phone': !_ctx.promotionTextHtml && !_ctx.organizationName,
        'site-header-ribbon__has-multiple-organizations': _ctx.hasMultipleOrganizations,
      },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.contactLink)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "site-header-ribbon__contact-link",
              to: _ctx.contactLink
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.websiteText("global__label_contact_link").value), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.hasMultipleOrganizations)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "site-header-ribbon__middle text-editor-content",
            innerHTML: _ctx.promotionTextHtml
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.websiteText("global__shopping_as").value) + " ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.organizationName), 1)
            ])
          ])),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_channel_switcher, { class: "site-header-ribbon__channel-switcher" })
      ])
    ])
  ], 2))
}